module.exports = __webpack_public_path__ + "static/global_adjustments-119518dd7c43a4baca00326fff62fa85.mp4";